import React from "react";
import { topicDictionary } from "../Util/tileDictionary";
import * as analytics from "../Util/Analytics/QuestionAnalytics";
const DataVisualizationToggle = ({
  onVizTypeChange,
  question,
  subQuestionValue,
  vizType,
  allowedOptions,
  locationAbbr,
}) => {
  const opts = Array.isArray(allowedOptions) && allowedOptions.length > 0
    ? allowedOptions.map((o) => String(o).toLowerCase())
    : ["graph", "table", "map"]; // default: all three
  const canShowGraph = opts.includes("graph");
  const canShowTable = opts.includes("table");
  const canShowMap = opts.includes("map");

  const effectiveLocationAbbr = locationAbbr || "ALL";
  function showMap() {
    analytics.selectMap();
    onVizTypeChange({
      vizType: "map",
      questionId: question.QuestionId,
      subQuestionId: subQuestionValue,
      locationAbbr: effectiveLocationAbbr,
    });
  }

  function showTable() {
    analytics.selectTable();
    onVizTypeChange({
      vizType: "table",
      questionId: question.QuestionId,
      subQuestionId: subQuestionValue,
      locationAbbr: effectiveLocationAbbr,
    });
  }

  function showGraph() {
    analytics.selectGraph();
    onVizTypeChange({
      vizType: "graph",
      questionId: question.QuestionId,
      subQuestionId: subQuestionValue,
      locationAbbr: effectiveLocationAbbr,
    });
  }

  return (
    <div className="sub-viz-type-toggle" style={{}}>
      { /* GRAPH */ }
      {canShowGraph && (
        <div className="viz-toggle__item">
          <button
            tabIndex="0"
            onKeyDown={(e) => e.code === "Enter" && showGraph()}
            className={`${vizType === "graph" ? "selected-viz" : ""} filter-data-button btn btn-white p-1 ${
              // If Graph is shown and Table follows, remove Graph's right radius
              canShowTable ? "removeRightBorderRadius" : ""
            }`}
            onClick={showGraph}
            style={
              vizType === "graph"
                ? {
                    backgroundColor: topicDictionary[question.TopicId].color,
                    color: "white",
                  }
                : { color: topicDictionary[question.TopicId].color }
            }
          >
            <span className="cdc-icon-chart_01"></span> Graph
          </button>
        </div>
      )}
      { /* TABLE */ }
      {canShowTable && (
        <div className="viz-toggle__item">
          <button
            tabIndex="0"
            onKeyDown={(e) => e.code === "Enter" && showTable()}
            className={`${vizType === "table" ? "selected-viz" : ""} filter-data-button btn btn-white p-1 ${(() => {
              // Middle button when all three present: remove both radii
              if (canShowGraph && canShowMap) return "removeLeftBorderRadius removeRightBorderRadius";
              // Only Graph+Table: Table is rightmost, remove left radius only
              if (canShowGraph && !canShowMap) return "removeLeftBorderRadius";
              // Only Table+Map: Table is leftmost, remove right radius only (existing behavior)
              if (!canShowGraph && canShowMap) return "removeRightBorderRadius";
              // Only Table: keep default rounded
              return "";
            })()}`}
            style={
              vizType === "table"
                ? {
                    backgroundColor: topicDictionary[question.TopicId].color,
                    color: "white",
                  }
                : { color: topicDictionary[question.TopicId].color }
            }
            onClick={showTable}
          >
            <span className="cdc-icon-table-light"></span> Table
          </button>
        </div>
      )}
      { /* MAP */ }
      {canShowMap && (
        <div className="viz-toggle__item">
          <button
            tabIndex="0"
            onKeyDown={(e) => e.code === "Enter" && showMap()}
            className={`${vizType === "map" ? "selected-viz" : ""} filter-data-button btn btn-white p-1 ${
              // If there is a button to the left (Graph or Table), remove left radius; else keep rounded
              (canShowTable || canShowGraph) ? "removeLeftBorderRadius" : ""
            }`}
            onClick={showMap}
            style={
              vizType === "map"
                ? {
                    backgroundColor: topicDictionary[question.TopicId].color,
                    color: "white",
                  }
                : { color: topicDictionary[question.TopicId].color }
            }
          >
            <span className="cdc-icon-map_01"></span> Map
          </button>
        </div>
      )}
    </div>
  );
};

export default DataVisualizationToggle;
